import type { InputProps } from '@chakra-ui/react'
import React from 'react'
import { BaseDatepicker } from '../Datepicker'
import { withFormControl, type FormFieldProps } from './hoc/withFormControl'

// Component-specific props
export interface DateFormControlComponentProps {
  type?: string
  placeholder?: string
  variant?: InputProps['variant']
  autoComplete?: boolean | string
  maxDate?: Date
  minDate?: Date
  enableTime?: boolean
  showIcon?: boolean
}

// Base component that handles date picker logic
export const DateFormControlBase = React.forwardRef<
  HTMLInputElement,
  DateFormControlComponentProps & FormFieldProps<Date | null, HTMLInputElement>
>((props, ref) => {
  const {
    // Form field props
    value,
    onChange,
    onBlur,
    isDisabled,
    // Component-specific props
    variant,
    placeholder,
    autoComplete,
    maxDate,
    minDate,
    enableTime,
    showIcon
  } = props

  return (
    <BaseDatepicker
      ref={ref}
      date={value ?? undefined}
      onDateChange={(date) => onChange(date ?? null)}
      onBlur={onBlur}
      isDisabled={isDisabled}
      autoComplete={autoComplete === false ? 'off' : 'on'}
      options={{
        maxDate,
        minDate,
        enableTime
      }}
      variant={variant}
      placeholder={placeholder}
      showIcon={showIcon}
    />
  )
})

  ; (DateFormControlBase as any).displayName = 'DateFormControlBase'

// Export the wrapped component
export const DateFormControl = withFormControl<DateFormControlComponentProps, Date | null, HTMLInputElement>(DateFormControlBase)